<template>
  <div class="wrapper">
    <div
      class="wrapper__hint-container"
      v-if="hint || label"
    >
      <BasicInputLabel
        v-if="label"
        :label
        :required
        :help
        class="wrapper__label"
      >
        <slot name="label"></slot>
      </BasicInputLabel>
      <div class="wrapper__hint">
        <BasicHint
          v-if="hint"
          :hint
        >
          <slot name="hint"></slot>
        </BasicHint>
      </div>
    </div>
    <slot></slot>
    <BasicAlert
      v-if="alertLabel"
      class="wrapper__alert--container"
      @click="showAlert(alertLabel)"
      :alertLabel
      :alertType
      wrap
      :hasBg="false"
      alertSize="small"
    />
  </div>
</template>

<script setup lang="ts">
  import type { WrapperFormElementProps } from '@designSystem/components'
  import { useDialog } from '@/features/interface/dialog'

  withDefaults(defineProps<WrapperFormElementProps>(), {
    label: '',
    required: false,
    help: '',
    hint: '',
    alertMessage: '',
    alertType: 'danger',
    wrap: false,
  })

  const showAlert = (message: string) => {
    const dialog = useDialog()
    dialog.showDialog({
      message,
      type: 'Error',
      closable: true,
    })
  }
</script>

<style lang="less">
  @import './WrapperFormElements.less';
</style>
